"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _RemindRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/RemindRound"));

// Generated by script, don't edit it please.
var RemindRound = (0, _createSvgIcon["default"])({
  as: _RemindRound["default"],
  ariaLabel: 'remind round',
  category: 'status',
  displayName: 'RemindRound'
});
var _default = RemindRound;
exports["default"] = _default;
module.exports = exports.default;